import { Routes, Route, Navigate, useParams } from "react-router-dom";

import RouteGuard from "./RouteGuard";
import ChorusFunders from "../pages/ChorusFunders/ChorusFunders";
// import { useParams } from "react-router-dom";

const RoutesList = () => {
  return (
    <Routes>
      {/* <Route path="/" element={<Navigate to="/funder" />} /> */}
      <Route path="search-funder" element={<ChorusFunders />} />
      {/* Entity guard */}
      {/* <Route path="/:entityType" element={<RouteGuard />}>
        <Route index element={<Home />} />

        <Route element={<DashboardLayout />}>
          <Route
            path="publication-analytics"
            element={<PublicationAnalytics />}
          />
          <Route path="dataset-analytics" element={<DatasetAnalytics />} />
          <Route path="publication-data" element={<PublicationData />} />
          <Route path="reports" element={<Reports />} />
          <Route path="lookup" element={<Lookup />} />
          <Route path="glossary" element={<Glossary />} />
          <Route path="about" element={<About />} />
        </Route>
      </Route> */}

      <Route path="*" element={<Navigate to="/search-funder" />} />
      {/* <Route path="*" element={<NotFound />} /> */}
    </Routes>
  );
};

export default RoutesList;
